// extracted by mini-css-extract-plugin
export default {"banner":"ConsentBanner_banner__XZxr3","text":"ConsentBanner_text__VZRj1","btn":"ConsentBanner_btn__4W--e","accept":"ConsentBanner_accept__nA+h+","later":"ConsentBanner_later__8EKhf"};